import { makeStyles, Typography } from "@material-ui/core"
import { FC } from "react"
import { useParams } from "react-router"
import { useNavigation } from "../../hooks/useNavigation"
import { usePractitioner } from "../../hooks/usePractitioner"
import { ComponentHeaderHeight } from "../../utils/constants"
import { colors } from "../../utils/theme"
import ChevronLeftIcon from "../atoms/ChevronLeftIcon"
import ClientProgress from "../molecules/ClientProgress"
import { HeaderHeight } from "../molecules/Header"
import StaffOverview from "../molecules/StaffOverview"
import TechniqueProfile from "../molecules/TechniqueProfile"

const useStyles = makeStyles((theme) => ({
  practitionerDetail: {
    paddingTop: HeaderHeight,
    backgroundColor: colors.neutral.white,
    flex: 1,
  },
  header: {
    height: ComponentHeaderHeight,
    maxWidth: 1440,
    margin: "0 auto",
  },
  line: {
    borderBottom: `1px solid ${colors.neutral.clay}`,
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center",
    flex: 1,
    width: "100%",
  },
  content: {
    maxWidth: 1440,
    padding: theme.spacing(2, 3),
  },
  title: {
    color: colors.neutral.denim,
  },
  addStaffButton: {
    width: 279,
  },
  navigation: {
    height: 92,
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    border: 0,
    backgroundColor: "transparent",
    paddingLeft: theme.spacing(3),
    outline: "none",
    cursor: "pointer",
  },
  chevron: {
    marginLeft: 4,
  },
  techniquesProgressContainer: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}))

const PractitionerDetail: FC = () => {
  const classes = useStyles()
  const params: { id: string } = useParams()
  const { practitioner, overview, techniqueProfile, clientProgress } =
    usePractitioner(params.id)
  const { toMyOrg } = useNavigation()

  return (
    <div className={classes.practitionerDetail}>
      <div className={classes.header}>
        <button className={classes.navigation} onClick={toMyOrg}>
          <ChevronLeftIcon className={classes.chevron} />
          <Typography variant="h2" className={classes.title}>
            {practitioner?.first_name} {practitioner?.last_name}
          </Typography>
        </button>
      </div>
      <div className={classes.line} />
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <StaffOverview staffOverviewData={overview} />
          <div className={classes.techniquesProgressContainer}>
            <TechniqueProfile techniqueProfileData={techniqueProfile} />
            <ClientProgress clientProgressData={clientProgress} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PractitionerDetail
